import { css } from '@emotion/core';

export const formWrapper = (theme) => css`
  padding-top: ${theme && theme.getSpacing(4, 'px')};
  padding-bottom: ${theme && theme.getSpacing(4, 'px')};
  padding-left: ${theme && theme.getSpacing(8, 'px')};
  padding-right: ${theme && theme.getSpacing(8, 'px')};
`;
